import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import SectionHeading from "../components/SectionHeading";
import { mission, founder, images } from "../data/siteData";

const AboutUs = () => {
  return (
    <div>
      <section className="bg-p3-cream py-16">
        <div className="max-w-4xl mx-auto px-5 text-center">
          <h1 className="font-heading font-extrabold text-4xl text-p3-navy mb-3">About Us</h1>
          <p className="text-p3-muted">Marketplace operators and strategists working with you, not just for you.</p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <SectionHeading eyebrow="Our purpose" title={mission.headline} />
            <p className="text-p3-muted leading-relaxed mb-6">{mission.intro}</p>
            <p className="font-semibold text-p3-navy mb-3">What our mission is NOT:</p>
            <ul className="space-y-2 mb-6">
              {mission.notList.map((item) => (
                <li key={item} className="flex items-start gap-2 text-sm text-p3-muted">
                  <XCircle size={16} className="text-red-400 mt-0.5 shrink-0" /> {item}
                </li>
              ))}
            </ul>
            <p className="text-p3-muted leading-relaxed mb-4">{mission.closing}</p>
            <blockquote className="border-l-4 border-p3-gold pl-4 italic text-p3-navy font-medium">
              &ldquo;{mission.quote}&rdquo;
            </blockquote>
          </div>
          <img src={images.mission} alt="Our mission" className="rounded-2xl shadow-xl w-full h-96 object-cover" />
        </div>
      </section>

      <section className="py-20 bg-p3-cream">
        <div className="max-w-4xl mx-auto px-5">
          <SectionHeading eyebrow="Leadership" title="Meet the Founder" center />
          <div className="bg-white rounded-2xl shadow-lg p-8 flex flex-col sm:flex-row items-center gap-8">
            <img
              src={images.founder}
              alt={founder.name}
              className="w-32 h-32 rounded-full object-cover shrink-0 border-4 border-p3-cream"
            />
            <div>
              <h3 className="font-heading font-bold text-xl text-p3-navy">{founder.name}</h3>
              <p className="text-p3-gold font-semibold text-sm mb-3">{founder.role}</p>
              <p className="text-sm text-p3-muted leading-relaxed">{founder.bio}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-p3-navy text-center">
        <div className="max-w-2xl mx-auto px-5">
          <h3 className="font-heading font-bold text-2xl text-white mb-5">Ready to build your Amazon growth plan?</h3>
          <Link
            to="/contact"
            className="inline-block bg-p3-gold hover:bg-p3-gold/90 text-p3-navy font-semibold px-8 py-3.5 rounded-lg transition-all"
          >
            GET IN TOUCH
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
